import $ from 'jquery';
window.$ = window.jQuery = require('jquery');
// const $ = window.jQuery;
// import niceselect from 'jquery-nice-select';
import styleSelect from 'styleselect';

import slick from "slick-carousel";

import magnificPopup from 'magnific-popup';

require("../scss/styles.scss");

$('.header_button').click(function() {
    $("body").toggleClass("header--shownav");
})
$('.nav_close, .nav_overlay').click(function() {
    $("body").toggleClass("header--shownav");
})

$('.nav_select').change(function() {
    const url = this.value;
    if(url) {
        location.href = url;
    }
});

// $('.gallery_item a').magnificPopup({
//     type:'image',
//     removalDelay: 300,
//     mainClass: 'mfp-fade'
// });

$("select").each(function() {
    styleSelect("#"+this.id);
});

$(".menu--seminars > a").click(function(e) {
    e.preventDefault();
    $(this).parent().toggleClass("menu--viewsubmenu")
});

$(".subnav-select").change(function(e) {
    e.preventDefault();
    window.location.href = $(this).val();
});


$("#Form_Form_Turnierhelfer").each(function() {
    function showHideHelfer() {
        const show = $("#Form_Form_Turnierhelfer").prop("checked");
        if(show) {
            $("#Form_Form_Turnierhelfer_Headline, #Form_Form_Abfahrt_Holder, #Turnierhelfer_Description, .helfer").show();
        } else {
            $("#Form_Form_Turnierhelfer_Headline, #Form_Form_Abfahrt_Holder, #Turnierhelfer_Description, .helfer").hide();
        }
    }

    $("#Form_Form_Turnierhelfer").change(function() {
        showHideHelfer();
    })

    showHideHelfer();
});

$("#Form_Form_AllDays").each(function() {
    function showHideDays() {
        const show = $("#Form_Form_AllDays input:checked").val() === "2";
        if(show) {
            $("#Form_Form_Days_Holder").show();
            $("#Form_Form_Welcome").parent().show();
        } else {
            $("#Form_Form_Days_Holder").hide();
            $("#Form_Form_Welcome").parent().hide();
        }
    }

    $("#Form_Form_AllDays input").change(function() {
        showHideDays();
    });

    showHideDays();

    function updatePrice() {
        let price = 0;
        const full = $("#Form_Form_AllDays input:checked").val() === "1";
        if (full) {
            price = 720;
        } else {
            const days = $("#Form_Form_Days input:checked").length;
            const priceMap = {
                "0": 0,
                "1": 150,
                "2": 290,
                "3": 420,
                "4": 540,
                "5": 650,
                "6": 720,
            }
            price = priceMap[String(days)];

            if($("#Form_Form_Welcome").is(":checked")) {
                price += 45;
            }
        }
        const formattedPrice = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(price);
        $("#price").text(formattedPrice);
    }

    $("#Form_Form_AllDays input, #Form_Form_Days input, #Form_Form_Welcome").change(function() {
        updatePrice();
    });

    updatePrice();
});

$(".section--gallery .gallery_items").slick({
    dots: true,
    fade: false,
    slidesToShow: 4,
    slidesToScroll: 4,
    arrows: false,
    // variableWidth: true
    responsive: [
        {
            breakpoint: 1000,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
        },
        {
            breakpoint: 450,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
});
